module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jbot1"))).then(() => parcelRequire('d0iPb'));